export default __webpack_public_path__ + "static/media/lessthan.aebf56a8.svg";